import {
  IFilterSet,
  isDateRangeFilter,
  isLimitedDateFilter,
  isMultiSelectFilter,
  isNullableFilter,
  isSingleSelectFilter,
  isTernaryFilter,
  isValueRangeFilter,
  normalizeDateRangeFilter,
  normalizeLimitedDateFilter,
  normalizeMultiSelectFilter,
  normalizeNullableFilter,
  normalizeSearch,
  normalizeSingleSelectFilter,
  normalizeTernaryFilter,
  normalizeValueRangeFilter,
} from '../typings'
import { IPropertyFilter } from '../typings/IPropertyFilter'

function normalizeSingleFilter<T>(filter: IPropertyFilter<T>): string {
  if (isDateRangeFilter(filter)) return normalizeDateRangeFilter(filter)
  if (isSingleSelectFilter(filter)) return normalizeSingleSelectFilter(filter)
  if (isMultiSelectFilter(filter)) return normalizeMultiSelectFilter(filter)
  if (isValueRangeFilter(filter)) return normalizeValueRangeFilter(filter)
  if (isTernaryFilter(filter)) return normalizeTernaryFilter(filter)
  if (isNullableFilter(filter)) return normalizeNullableFilter(filter)
  if (isLimitedDateFilter(filter)) return normalizeLimitedDateFilter(filter)
  return ''
}

export function normalizeFilters<U, T extends IFilterSet<U>>(
  filterSet: T,
): T & { validKeys: (keyof T['filters'])[] } {
  const { filters, search } = filterSet

  const validKeys: (keyof T['filters'])[] = []

  const normalized = Object.keys(filters)
    .map((key) => {
      const normValue = normalizeSingleFilter(filters[key])

      if (normValue !== '') validKeys.push(key)

      return normValue
    })
    .filter((x) => x !== '')

  const appliedCount = normalized.length

  if (!!search && search.value !== '') {
    normalized.push(normalizeSearch(search))
  }

  return {
    ...filterSet,
    normalizedFilters: normalized,
    appliedCount,
    validKeys,
  }
}
